import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { cn } from '@/lib/cn'
import styles from './Button.module.css'

type ButtonVariant = 'solid' | 'outline'

type ButtonProps = {
  variant?: ButtonVariant
  fullWidth?: boolean
  loading?: boolean
  children: ReactNode
} & ButtonHTMLAttributes<HTMLButtonElement>

export function Button({
  variant = 'solid',
  fullWidth = false,
  loading = false,
  className,
  type = 'button',
  children,
  disabled,
  ...props
}: ButtonProps) {
  return (
    <button
      type={type}
      className={cn(
        styles.button,
        {
          [styles['button--outline']]: variant === 'outline',
          [styles['button--solid']]: variant === 'solid',
          [styles['button--full-width']]: fullWidth,
          [styles['button--loading']]: loading,
        },
        className,
      )}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...props}
    >
      {loading && <span className={styles.spinner} aria-hidden="true" />}
      {children}
    </button>
  )
}
